// @flow
import type { Map } from "immutable"

import { RESERVATION_PART_CONFIG } from "../../../booking/scenes/ReservationForm/consts/reservationConsts"
import type { PART_TYPE } from "../../../booking/scenes/ReservationForm/consts/reservationConsts"

export type DepartureArrival = Map<"where" | "when", Map<string, any>>

export type Airline = {
  name: string,
  logo: string,
  code: string,
  closeBookingHours?: number,
}

export type Flight = {
  // Common with Transfer
  id: string,
  naturalId: ?string,
  departure: ?DepartureArrival,
  arrival: ?DepartureArrival,
  // eslint-disable-next-line flowtype/no-weak-types
  vehicle: Object,
  type: PART_TYPE,
  airline: Airline, // called carrier in Transfer
  // eslint-disable-next-line flowtype/no-weak-types
  seatmap: Object,

  // Special for Flight
  number: ?number,
  bagsRecheckRequired: ?boolean,
  guarantee: ?boolean,
  isHidden: boolean,

  boardingPassAvailableAt: ?Date,

  priorityBoarding: boolean,
  isCabinBagsWithPriorityBoarding: boolean,
  // eslint-disable-next-line flowtype/no-weak-types
  operatingAirline: Object,
  pnr: string,
  // eslint-disable-next-line flowtype/no-weak-types
  status: Object, // for schedule change
  // eslint-disable-next-line flowtype/no-weak-types
  amenities: null,
  fareCategory: ?string,
}

const defaultFlight = {
  id: null,
  naturalId: null,
  departure: null,
  arrival: null,
  vehicle: null,
  type: RESERVATION_PART_CONFIG.flight.type,
  airline: null,
  seatmap: null,
  number: null,
  bagsRecheckRequired: null,
  guarantee: null,
  isHidden: false,

  boardingPassAvailableAt: null, // ?timestamp

  priorityBoarding: false,
  isCabinBagsWithPriorityBoarding: false,
  operatingAirline: null,
  pnr: null, // string

  status: null, // for schedule change

  amenities: null,
  fareCategory: null,
}

export default defaultFlight
